// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__34uu1","box":"WorkspacesBox_box__2A4Zf","node":"WorkspacesBox_node__3hAdE"};